import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-land",
  "use": "icon-land-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-land\"><defs><style type=\"text/css\"></style></defs><path d=\"M973.218909 465.454545h-372.363636L558.545455 0h372.363636l42.309818 465.454545z m-127.301818-372.363636H660.48l25.390545 279.272727h185.413819l-25.367273-279.272727z m135.773091 465.454546L1024 1024H651.636364l-42.309819-465.454545h372.363637z m-85.015273 93.090909h-185.413818l25.367273 279.272727h185.437091l-25.390546-279.272727z m-482.373818-186.181819L380.439273 93.090909H178.106182L144.244364 465.454545h270.056727z m8.448 93.09091H135.796364L101.934545 930.909091h354.676364l-33.861818-372.363636zM465.454545 0l93.09091 1024H0L93.090909 0h372.363636z\" fill=\"#ffffff\" p-id=\"3830\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/land.svg
// module id = Ebv5
// module chunks = 102